import { TableRow, TableCell, Typography, Alert } from '@mui/material'
import type { FC } from 'react'

interface Props {
  colSpan: number
  message?: string
}

const NoResults: FC<Props> = ({ colSpan, message = 'No results were found.' }) => (
  <TableRow>
    <TableCell component="th" scope="row" colSpan={colSpan} sx={{ verticalAlign: 'top' }}>
      <Alert severity="info">
        <Typography variant="body2">{message}</Typography>
      </Alert>
    </TableCell>
  </TableRow>
)

export default NoResults
